<template>
<div id="bpor-advert-condition">
  <table class="bpor-advert" aria-hidden="true" style="border:3px solid #0E487F">
    <tbody>
      <tr>
        <td class="advert-left-cell">
          <div style="text-align:center"> 
              <img src="/images/Advert-logos/FilterAdvert.jpg" alt="Sign up and create a free health research account to make it even easier to take part in heath and care research. Click here to sign up (This will open in a new window)."> 
          </div>
        </td>
        <td class="advert-right-cell">
          <div class="title">Create a free health research account to make it even easier to take part in health and care research.</div>
            <button id="advert-link" aria-hidden="true" type="button" class="btn-dark advert-btn" tabindex="-1" onclick="window.open('https://volunteer.bepartofresearch.nihr.ac.uk/participants/introduction')"> 
              Sign up <i class="fa-solid fa-up-right-from-square"></i>
            </button>
        </td>
      </tr>
    </tbody>
  </table>
  <br/>
</div>
</template>

<script>
export default {

}
</script>


